import { useMemo } from "react";
import { isAllowed } from "../helpers";
import useScopes from "./useScopes";

export default function useIsAllowed(scopes: string[][]) {
    const tokenScopes = useScopes();
    return useMemo(() => isAllowed(scopes, tokenScopes), [tokenScopes, scopes]);
}
